var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newStatus)?_c('p',{staticClass:"course-list-info-label is-size-8 has-text-weight-bold has-text-white has-background-new"},[_vm._v("NEW")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }